import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

import WolfLogo from '@assets/volf-logo.svg';

import useStyles from './styles';

const Loading = ({
  classNameWrapper,
  customHeader,
  customText,
  customIcon,
}) => {
  const classes = useStyles();

  return (
    <div className={cx(classes.container, classNameWrapper)}>
      <div className={classes.iconContainer}>
        <CircularProgress size={100} className={classes.circleIcon} />
        <img
          src={customIcon || WolfLogo}
          alt="Wolf Logo"
          className={classes.wolfLogo}
        />
      </div>
      <h1>{customHeader || 'Loading'}</h1>
      <div>{customText || 'The page is loading, just a moment please'}</div>
    </div>
  );
};

Loading.propTypes = {
  classNameWrapper: PropTypes.string,
  customHeader: PropTypes.string,
  customText: PropTypes.string,
  customIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};
export default Loading;
